import React from 'react';
import styles from './FormField.module.scss';
import { BadgeInfo   } from "lucide-react";

const FormField = ({
  label,
  name,
  type = 'text',
  value,
  onChange,
  required = false,
  error = '',
  placeholder = '',
  disabled = false,
  className = '',
  tooltip = '', 
  ...inputProps
}) => {

  
  const getFieldClasses = () => {
    let classes = `form-control ${styles.input}`;
    
    if (error) {
      classes += ` ${styles.inputError}`;
    }
    
    if (disabled) {
      classes += ` ${styles.inputDisabled}`;
    }
    
    return classes;
  };

  return (
    <div className={`${styles.formField} ${className}`}>
      {label && (
        <label className={`form-label ${styles.label}`}>
          {label}
          {required && <span className={styles.required}>*</span>}
          {tooltip && (
            <span className={styles.infoWrapper}>
              <BadgeInfo size={14} className={styles.infoIcon}/>
              <span className={styles.tooltipText}>{tooltip}</span>
            </span>
          )}
        </label>
      )}

      <input
        name={name}
        type={type}
        value={value || ""}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        className={getFieldClasses()}
        onChange={onChange}
        {...inputProps}
      />

      {error && <div className={styles.errorMessage}>{error}</div>}
    </div>
  );
};

export default FormField;
